// 判断是否是空值 undefined null '' [] {}
import { typeList } from '@/pages/user/Login/const'
import Cookies from 'js-cookie';

const userAgent = window.navigator.userAgent;

export const isEmpty = (value: any) => {
  let type = Object.prototype.toString.call(value);
  type = type.substring(1, type.length - 1).split(' ')[1];
  if (type === 'Null' || type === 'Undefined'
    || (type === 'String' && value === '')
    || (type === 'Array' && value.length <= 0)
    || (type === 'Object' && Object.keys(value).length <= 0)) {
    return true;
  }
  return false;
}

// 去除 HTML 标签，获取纯文本
export const stripHTMLTags = (html) => {
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const plainText = tempDiv.textContent || tempDiv.innerText || "";
  tempDiv = null;
  return plainText;
}

// 判断是否是内部打开
export const isInnerOpen = (type: number) => {
  return type === typeList[2].value
}

// 获取url参数
export const getUrlParam = (name, url = location.href) => {
  let pattern = new RegExp('[?|&|#]' + name + '=([^&|#]+)', 'g');
  let matcher = pattern.exec(url);
  let items = null;
  if (null != matcher) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (e) {
        items = matcher[1];
      }
    }
  }
  return items;
}

// 通过名称获取路径参数
export const getUrlParamByPath = (name: string, url: string = location.href) => {
  try {
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split('/').filter(segment => segment !== '');
    
    // 查找名称在路径中的位置
    const index = pathSegments.findIndex(segment => segment === name);
    
    // 如果找到了名称，返回下一个路径段的值
    if (index !== -1 && index < pathSegments.length - 1) {
      return pathSegments[index + 1];
    }
    
    return null;
  } catch (e) {
    console.error('getUrlParamByPath error:', e);
    return null;
  }
}



// 将对象转换成url参数
export const objToUrlParams = (obj: any, withMark = true, encode = true) => {
  const params = []
  for (let key in obj) {
    const value = obj[key]
    // 过滤掉值为 undefined、null、'' 的参数
    if (value === undefined || value === null || value === '') {
      continue
    }
    params.push(`${key}=${encode ? encodeURIComponent(value) : value}`)
  }
  return (withMark && params.length ? '?' : '') + params.join('&')
}

export const isWechat = function () {
  // @ts-ignore
  return "micromessenger" == navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
}

// 判断是否为抖音
export const isDouYinEnvironment = /bytedance/i.test(userAgent) || /bytelocale/i.test(userAgent);

// 判断是否在微信环境
export const isWeChatNew = /MicroMessenger/i.test(navigator.userAgent);

// 判断是否在 PC 上的微信环境
export const isPCWeChat = isWeChatNew && /WindowsWechat/i.test(navigator.userAgent);

export const isSourceWeixin = () => {
  return isWeChatNew || isPCWeChat
}

// 获取抖音版本
export const getDouyinVersion = () => {
  const APP_VERSION_REGX = {
    android: new RegExp("app_version/", "i"),
    ios: new RegExp("aweme_", "i"),
  };
  const ua = navigator.userAgent;
  const os = /(Android);?\s+([\d.]+)?/i.test(ua) ? "android" : "ios";

  return parseFloat(ua.split(APP_VERSION_REGX[os])[1]);
}

// 版本比较
export const compareVersion = (userAgentVersion, baseVersion) => {
  if (!userAgentVersion) {
    return false
  }
  const versionToNumbers = version => version.split('.').map(Number);

  const [userMajor, userMinor, userPatch] = versionToNumbers(userAgentVersion);
  const [baseMajor, baseMinor, basePatch] = versionToNumbers(baseVersion);

  if (userMajor > baseMajor) return true;
  if (userMajor < baseMajor) return false;

  if (userMinor > baseMinor) return true;
  if (userMinor < baseMinor) return false;

  return userPatch >= basePatch;
}

// 使用a标签实现URL跳转
export const jumpToUrl = (url: string, target: '_blank' | '_self' = '_blank') => {
  const link = document.createElement('a');
  link.href = url;
  link.target = target;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const getUcCode = () => {
  return Cookies.get('platform_cs') === '1GAME' ? process.env.REACT_APP_UC_CODE_1GAME : process.env.REACT_APP_UC_CODE;
}